import React, { useEffect, useState } from 'react'
import logoW from 'image/wLogo.png';
import './splash.css';
function Splash(props: { showing: boolean }) {
  const [showing, setShowing] = useState(true)
  const [flashing, setflashing] = useState(true)
  useEffect(() => {
    if (!props.showing) {
      setTimeout(()=>{
        setShowing(false)
        setflashing(false)
      },1000)
    }else{
      setShowing(true)
    }
  }, [props.showing])


  return (
    showing ? (
      <div className={`splash ${(props.showing ? '' : 'doneLoading')}`}>
        <div className="mainBox">
          <div>
            <div className="BackDrop"></div>
            <img className="icon" src={logoW} alt="" />
            {
              flashing && (
                <div className="light"></div>
              )
            } 
          </div>
          <div className="text">
            <span>Project Argon</span>
          </div>
        </div>
      </div>
    ):<></>

  )
}

export default Splash
